import get from 'lodash/get';
import replace from 'lodash/replace';
import upperCase from 'lodash/upperCase';
import findKey from 'lodash/findKey';

import { AFEX } from 'config';
import { CATEGORY_ID_MAP } from 'context/updates/constants';

export const getCategoryNames = categoriesIds =>
  categoriesIds
    .map(categoryId => findKey(CATEGORY_ID_MAP, x => x === categoryId))
    .filter(Boolean)
    .map(upperCase);

export const getAuthorDetails = post => {
  const author = get(post, 'author', {});
  return {
    name: author.name,
    avatar: get(author, 'avatar_urls.wordpress_96'),
  };
};

export const getDisqusConfig = ({ slug, title }) => {
  return {
    shortname: AFEX.DISQUS_APP_NAME,
    config: { identifier: slug, title },
  };
};

export const getShareUrl = (postTitle, platform) => {
  if (typeof window === 'undefined') return;

  const title = encodeURIComponent(postTitle);
  const url = encodeURIComponent(window.location);
  const shareUrlsMap = {
    facebook: `https://www.facebook.com/sharer/sharer.php??u=${url}&t=${title}`,
    twitter: `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`,
    whatsapp: `https://wa.me?text=${url}&title=${title}`,
  };
  return shareUrlsMap[platform];
};

export const normalizePost = post => {
  const oldUrlPattern = `com/${AFEX.OLD_ADMIN_DOMAIN_NAME}/wp-content`;
  const newUrlPattern = `com/${AFEX.NEW_ADMIN_DOMAIN_NAME}/wp-content`;
  const newContent = replace(
    get(post, 'content'),
    new RegExp(oldUrlPattern, 'g'),
    newUrlPattern
  );

  return {
    ...post,
    content: newContent,
  };
};
